'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tab = require('react-bootstrap/lib/Tab');

var _Tab2 = _interopRequireDefault(_Tab);

var _TabPane = require('./TabPane');

var _TabPane2 = _interopRequireDefault(_TabPane);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Tab2.default.Pane = _TabPane2.default;

exports.default = _Tab2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Tab.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Tab.js
 ** module chunks = 0
 **/